import { app } from './Api';

const uploadPendencia = async (file, mes, ano) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('mes', mes);
  formData.append('ano', ano);

  return app.post('pendencias', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export { uploadPendencia };

